import React from 'react';
import { PRIMARY } from '../legacy-ball/table-management/designTokens';
import { SECTION_LABELS, TOTAL_SECTIONS } from './constants';

// SECTION_LABELS and TOTAL_SECTIONS are re-exported for consumers
// that need the canonical values when rendering DotIndicators.
export { SECTION_LABELS, TOTAL_SECTIONS };

export interface DotIndicatorsProps {
  totalDots: number;
  activeIndex: number;
  onDotClick: (index: number) => void;
  sectionNames: string[];
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 0',
  },
  dot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: '#c0c0c0',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  },
  activeDot: {
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    backgroundColor: PRIMARY,
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  },
};

export const DotIndicators: React.FC<DotIndicatorsProps> = ({
  totalDots,
  activeIndex,
  onDotClick,
  sectionNames,
}) => {
  return (
    <div role="tablist" aria-label="Menu sections" style={styles.container}>
      {Array.from({ length: totalDots }, (_, index) => {
        const isActive = index === activeIndex;
        const label = sectionNames[index] || `Section ${index + 1}`;
        return (
          <button
            key={index}
            role="tab"
            aria-label={`Go to ${label}`}
            aria-selected={isActive}
            onClick={() => onDotClick(index)}
            style={isActive ? styles.activeDot : styles.dot}
          />
        );
      })}
    </div>
  );
};

export default DotIndicators;
